import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Column, Row, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { classifyConfidence } from '../utils/classifyConfidence';
import { formatMoney } from '../utils/formatOpportunityValues';
import { confidenceLabel, kindLabel } from '../utils/opportunityLabels';
import { opportunityEvidenceLines } from './evidence/opportunityEvidenceLines';
export const GetOpportunityRowTID = (parentTestId)=>getTestIds(parentTestId);
export const OpportunityRow = (param)=>{
    let { opportunity, clientLabel, locale, testId } = param;
    const { OpportunityRowTestIds } = useMemo(()=>GetOpportunityRowTID(testId), [
        testId
    ]);
    const { t: texts } = useLocaleKeys('pulseOpportunities');
    const evidenceLines = opportunityEvidenceLines(opportunity, texts.evidence, locale);
    return /*#__PURE__*/ _jsxs(Column, {
        testId: OpportunityRowTestIds.Root(),
        gap: 4,
        children: [
            /*#__PURE__*/ _jsxs(Row, {
                justifyContent: "space-between",
                alignItems: "baseline",
                gap: 8,
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph2",
                        weight: "normal",
                        testId: OpportunityRowTestIds.Subject(),
                        children: opportunity.subject
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph2",
                        weight: "normal",
                        testId: OpportunityRowTestIds.Impact(),
                        children: formatMoney(opportunity.estAnnualImpact, locale)
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Row, {
                gap: 8,
                wrap: true,
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph3",
                        skin: "secondary",
                        testId: OpportunityRowTestIds.Kind(),
                        children: kindLabel(opportunity.kind, texts.kind)
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph3",
                        skin: "secondary",
                        testId: OpportunityRowTestIds.Client(),
                        children: clientLabel
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph3",
                        skin: "secondary",
                        testId: OpportunityRowTestIds.Confidence(),
                        children: confidenceLabel(classifyConfidence(opportunity.confidence), texts.confidence)
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Column, {
                gap: 2,
                children: evidenceLines.map((line, index)=>/*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph3",
                        skin: "secondary",
                        testId: OpportunityRowTestIds.EvidenceLine(index),
                        children: line
                    }, index))
            })
        ]
    });
};
